module.exports = __webpack_public_path__ + "media/fail.5a298602.mp3";